import {
  CONSENT_VERSION, setConsentAccount, setConsentPersistence,
  applyConsentRecord, fromAccountConsent, commitConsent, restrictConsent,
} from "./consent";

let initialized = false;

export default function initAccountConsent(store, api) {
  if (initialized) return;
  initialized = true;
  let ownerId = null;
  let generation = 0;
  let saving = false;
  let lastRecord;
  let withdrawalPrevious = null;

  const restoreUser = (user) => {
    if (!user || !user.id) return;
    const id = String(user.id);
    if (saving && id === ownerId) return;
    const record = fromAccountConsent(id, user.consent_preferences);
    const signature = JSON.stringify(record);
    if (id === ownerId && signature === lastRecord) return;
    ownerId = id;
    lastRecord = signature;
    withdrawalPrevious = null;
    generation += 1;
    setConsentAccount(id);
    applyConsentRecord(record, { source: "account" });
  };

  // Register before vendor identity hooks, so user_info consent takes precedence.
  restoreUser(store.getters.customer);
  store.subscribe((mutation) => {
    if (mutation.type === "AUTH_SUCCESS") restoreUser(mutation.payload);
    if (mutation.type === "AUTH_LOGOUT") {
      generation += 1;
      ownerId = null;
      lastRecord = undefined;
      withdrawalPrevious = null;
      setConsentAccount(null);
      applyConsentRecord(null, { source: "logout", skipReload: true });
    }
  });

  setConsentPersistence((preferences) => {
    if (!ownerId) return commitConsent(preferences);
    if (saving) return Promise.reject(new Error("A privacy preference update is in progress"));
    saving = true;
    const requestOwner = ownerId;
    const requestGeneration = generation;
    const restrictedFrom = restrictConsent(preferences);
    // Retain the reload transition if a failed withdrawal is retried.
    if (restrictedFrom.analytics && !preferences.analytics) withdrawalPrevious = restrictedFrom;
    const previous = withdrawalPrevious || restrictedFrom;

    const persist = async () => {
      try {
        const response = await api.patch("/account/consent", {
          version: CONSENT_VERSION,
          analytics: preferences.analytics === true,
          experience: preferences.sessionReplay === true,
          expected_account_id: requestOwner,
        });
        if (generation !== requestGeneration || ownerId !== requestOwner) {
          throw new Error("The signed-in account changed during the update");
        }
        const value = response && response.data && response.data.consent_preferences;
        const record = fromAccountConsent(requestOwner, value);
        if (
          !response || response.status !== 200 || !record
          || response.data.account_id !== requestOwner
          || record.analytics !== (preferences.analytics === true)
          || record.experience !== (preferences.sessionReplay === true)
        ) {
          throw new Error("Could not save privacy preferences");
        }
        store.commit("UPDATE_CONSENT_PREFERENCES", value);
        lastRecord = JSON.stringify(record);
        const result = applyConsentRecord(record, { source: "save", previous });
        withdrawalPrevious = null;
        return result;
      } finally {
        saving = false;
      }
    };
    return persist();
  });
}
